// extracted by mini-css-extract-plugin
export var content = "locator-module--content--cb793";
export var contentContainer = "locator-module--content-container--1f094";
export var locatorSlice = "locator-module--locator-slice--a01a6";
export var mapContainer = "locator-module--map-container--d6ee6";
export var offsetBorder = "locator-module--offset-border--23c37";
export var overlay = "locator-module--overlay--5bebf";